import Footer from "../../component/Footer";
import Navbar from "../../component/Navbar";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
// import { Textarea } from "@material-tailwind/react";

const allTherapists = JSON.parse(localStorage.getItem("allTherapists"))
  ? JSON.parse(localStorage.getItem("allTherapists"))
  : [];
console.log(allTherapists);

function TherapistApplication() {
  const navigator = useNavigate();
  const THERAPISTURL =
    "https://thrive-mqy3.onrender.com/v1/auth/therapist/register";
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [age, setAge] = useState("");
  const [email, setEmail] = useState("");
  const [state, setState] = useState("");
  const [specialization, setSpecialization] = useState("");
  const [experience, setExperience] = useState("");
  const [image, setImage] = useState("");
  const [bio, setBio] = useState("");
  const [gender, setGender] = useState("");

  const alertUser = () => {
    // e.preventDefault();
    setTimeout(() => {
      Swal.fire({
        title: "Successful",
        text: ` Your Application has been received we will get back to you via mail after reviewing your credentials `,
        color: "#186F65",
        confirmButtonColor: "#508D69",
        icon: "success",
      }).then((item) => {
        if (item.isConfirmed) {
          navigator("/");
        }
      });
    }, 0);
  };

  const sendApplication = async () => {
    try {
      const therapistDetails = {
        firstName,
        lastName,
        email,
        specialization,
        yearsOfExperience: experience,
        location: state,
        age,
        bio,
        image,
        gender,
      };
      console.log("Therapist Details", therapistDetails);
      const HelpData = {
        method: "POST",
        body: JSON.stringify(therapistDetails),
        headers: {
          "Content-Type": "application/json",
        },
      };

      const response = await fetch(THERAPISTURL, HelpData);
      const data = await response.json();
      console.log("therapistdata", data);
      // localStorage.setItem("")
      alertUser();
    } catch (error) {
      console.log("something went wrong" + error);

      return;
    }
  };

  function handleSubmit(e) {
    e.preventDefault();
    sendApplication();
    alertUser();
  }

  return (
    <div className="bg-[#D9D9D9]">
      <Navbar />
      <h1 className="text-[#295700] text-xl font-semibold text-center py-8 md:border-b-2 border-[#295700] md:mb-8">
        THERAPIST APPLICATION FORM
      </h1>
      <form>
        <section className="flex flex-col items-center bg-[#D9D9D9] ">
          {/* --------------Main Area---------------- */}
          <div className="flex flex-col w-[60%] mx-auto items-center gap-4 ">
            {/* -----------Input Section----------- */}
            <div className="flex flex-col gap-1 w-full items-center"></div>
            <div className="flex flex-col gap-1 w-full items-center">
              <label className="self-start md:w-[80%] mx-auto text-[#295700]">
                <strong>FIRST NAME</strong>
              </label>

              <input
                onChange={(e) => setFirstName(e.target.value)}
                type="text"
                placeholder="Your firstname"
                className="block w-96 md:w-[80%] rounded-md shadow-md px-3 py-2 border border-[#295700] focus:outline-none focus:border-[#508D69]"
                required
              />
            </div>
            <div className="flex flex-col  w-full items-center">
              <label className="self-start md:w-[80%] mx-auto text-[#295700]">
                <strong>LAST NAME</strong>
              </label>

              <input
                onChange={(e) => setLastName(e.target.value)}
                type="text"
                placeholder="Your lastname"
                className="block w-96 md:w-[80%] rounded-md shadow-md px-3 py-2 border border-[#295700] focus:outline-none focus:border-[#508D69]"
                required
              />
            </div>
            <div className="flex flex-col  w-full items-center">
              <label className="self-start md:w-[80%] mx-auto text-[#295700]">
                <strong>AGE</strong>
              </label>

              <input
                onChange={(e) => setAge(e.target.value)}
                type="number"
                placeholder="Your Age"
                className="block w-96 md:w-[80%] rounded-md shadow-md px-3 py-2 border border-[#295700] focus:outline-none focus:border-[#508D69]"
                required
              />
            </div>
            <div className="flex flex-col  w-full items-center">
              <label className="self-start md:w-[80%] mx-auto text-[#295700]">
                <strong>EMAIL</strong>
              </label>

              <input
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                placeholder="Enter your Email"
                className="block w-96 md:w-[80%] rounded-md shadow-md px-3 py-2 border border-[#295700] focus:outline-none focus:border-[#508D69]"
                required
              />
            </div>
            <div className="flex flex-col  w-full items-center">
              <label className="self-start md:w-[80%] mx-auto text-[#295700]">
                <strong>SPECIALTY</strong>
              </label>

              <input
                onChange={(e) => setSpecialization(e.target.value)}
                type="text"
                placeholder="Your specialty"
                className="block w-96 md:w-[80%] rounded-md shadow-md px-3 py-2 border border-[#295700] focus:outline-none focus:border-[#508D69]"
                required
              />
            </div>
            <div className="flex flex-col  w-full items-center">
              <label className="self-start md:w-[80%] mx-auto text-[#295700]">
                <strong>EXPERIENCE</strong>
              </label>

              <input
                onChange={(e) => setExperience(e.target.value)}
                type="text"
                placeholder="Your years of experience"
                className="block w-96 md:w-[80%] rounded-md shadow-md px-3 py-2 border border-[#295700] focus:outline-none focus:border-[#508D69]"
                required
              />
            </div>
            <div className="flex flex-col  w-full items-center">
              <label className="self-start md:w-[80%] mx-auto text-[#295700]">
                <strong>GENDER</strong>
              </label>

              <input
                onChange={(e) => setGender(e.target.value)}
                type="text"
                placeholder="Your gender"
                className="block w-96 md:w-[80%] rounded-md shadow-md px-3 py-2 border border-[#295700] focus:outline-none focus:border-[#508D69]"
                required
              />
            </div>
            <div className="flex flex-col  w-full items-center">
              <label className="self-start md:w-[80%] mx-auto text-[#295700]">
                <strong>STATE</strong>
              </label>

              <input
                onChange={(e) => setState(e.target.value)}
                type="text"
                placeholder="State"
                className="block w-96 md:w-[80%] rounded-md shadow-md px-3 py-2 border border-[#295700] focus:outline-none focus:border-[#508D69]"
                required
              />
            </div>
            <div className="flex flex-col gap-3 w-full items-center">
              <label className="self-start md:w-[80%] mx-auto text-[#295700]">
                <strong>UPLOAD HEADSHOT</strong>
              </label>

              <input
                type="file"
                onChange={(e) => setImage(e.target.files[0])}
                accept=".jpeg,.png,"
                placeholder="Upload your headshot"
                className="block w-96 md:w-[80%] rounded-md shadow-md px-3 py-2 border border-[#295700] focus:outline-none focus:border-[#508D69]"
                required
              />
            </div>
            {/* <div className="flex flex-col  w-full items-center">
              <label className="self-start md:w-[80%] mx-auto text-[#295700]">
                <strong>UPLOAD RESUME</strong>
              </label>

              <input
                type="file"
                laceholder="Upload your resume"
                accept=".pdf"
                className="block w-96 md:w-[80%] rounded-md shadow-md px-3 py-2 border border-[#295700] focus:outline-none focus:border-[#508D69]"
                required
              />
            </div>{" "} */}

            <div className="flex flex-col  w-full items-center">
              <label className="self-start md:w-[80%] mx-auto text-[#295700]">
                <strong>BIO</strong>
              </label>

              <textarea
                type="text"
                placeholder="write about yourself"
                className="block w-96 md:w-[80%] rounded-md shadow-md px-3 py-2 border border-[#295700] focus:outline-none resize-none focus:border-[#508D69]"
                required
                cols={30}
                onChange={(e) => setBio(e.target.value)}
              ></textarea>
            </div>
            <div className="mt-8 ">
              <input
                onClick={handleSubmit}
                value="SUBMIT"
                type="submit"
                className="block w-60 font-semibold text-center text-white bg-[#295700] py-2 rounded-md mb-8"
              />
            </div>
          </div>
        </section>
      </form>
      <Footer />
    </div>
  );
}

export default TherapistApplication;
